/*
 * @Author: gaobin
 * @Date: 2025-06-09 14:08:38
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-07-31 16:13:44
 * @Description: 共用接口
 */
const commonMap = {
  // 上传文件
  uploadFileExt: '/usb/upload/file',
  // 获取中国段物流费
  getLogisticsFee: '/usb/uwb-app/api/v1/product/freightEstimate',

  // 上传图片
  imageUploadExt: '/usb/uwb-app/api/v1/search/imageUpload',
  // 上传图片-获取图片路径
  uploadImageGetUrlExt: '/usb/uwb-app/api/v1/upload/image',
  // 发送验证码
  sendEmailCode: '/usb/uwb-app/api/v1/user/sendEmailCode',
  // 汇率
  getRateExt: '/usb/uwb-app/api/v1/home/getRateByType',
  // 图搜找相似
  searchSame: '/usb/uwb-app/api/v1/search/appSearchSameParagraph',

  // 下载wgt
  downLoadWgt: '/usb/uwb-app/api/v1/home/downloadWgt',

  // 获取最新版本信息
  getNewVersion: '/usb/uwb-app/api/v1/home/getLatestWqt',
  // 埋点上报服务器
  pushTraceExt: '/usb/uwb-app/api/v1/trace/pushEvent',
};

export default commonMap;
